module.exports = __webpack_public_path__ + "img/img20.fa9bcbc6.svg";